@if (pageReady) {
  <div data-page-container>
    <app-inactivity-logout-banner></app-inactivity-logout-banner>
    <app-top-nav></app-top-nav>
    <main>
      <router-outlet></router-outlet>
    </main>
    <app-footer></app-footer>
  </div>
}
